import { c as _c } from "react/compiler-runtime";
import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api';
import { AffiliateDashboardVendorsInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-vendors-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
export const useAffiliateDashboardVendors = shouldFetch => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    user
  } = useUser();
  let t1;
  if ($[1] !== shouldFetch || $[2] !== user) {
    t1 = () => {
      if (!user || !shouldFetch) {
        return;
      }
      return [`${AFFILIATE_DASHBOARD_API}/stats-by-vendors`, RequestModuleEnum.Contacts];
    };
    $[1] = shouldFetch;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return useControlledSwr(t1, fetcher);
};